import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  setEditCompanyOpen: Dispatch<SetStateAction<boolean>>;
  setCreateOfferOpen: Dispatch<SetStateAction<boolean>>;
  emptyFields: string[];
}

export default function OfferWarningModal({
  setOpen,
  isOpen,
  setEditCompanyOpen,
  setCreateOfferOpen,
  emptyFields
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog maxWidth="md" disableEscapeKeyDown={true} open={isOpen} onClose={() => setOpen(false)}>
      <DialogTitle>{t(translations.pages.companyDetailPage.offerWarning.title())}</DialogTitle>
      <DialogContent style={{ overflow: 'unset' }}>
        <Grid item>{t(translations.pages.companyDetailPage.offerWarning.description())}</Grid>
        <Grid item>{t(translations.pages.companyDetailPage.offerWarning.emptyFields())}</Grid>
        <Grid container item direction="column" spacing={1}>
          <Grid item>
            {emptyFields.map(field => (
              <b>{field + ', '}</b>
            ))}
          </Grid>
          <Grid item>{t(translations.pages.companyDetailPage.offerWarning.explanation())}</Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            setOpen(false);
            setEditCompanyOpen(true);
          }}
        >
          {t(translations.pages.companyDetailPage.offerWarning.editCompanyButton())}
        </Button>
        <Button
          onClick={() => {
            setOpen(false);
            setCreateOfferOpen(true);
          }}
        >
          {t(translations.pages.companyDetailPage.offerWarning.createOfferButton())}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
